// extracted by mini-css-extract-plugin
export default {"html":"Loader_html__dB0DC","dark":"Loader_dark__2dZgF","light":"Loader_light__gi+QC","on":"Loader_on__C-+5m","off":"Loader_off__dd3Ub","_hide_loading":"Loader__hide_loading__r9rZb"};